$(function () {
	if (!!$(".section-tabs").length) {
		const container = document.querySelector(".section-tabs");
		const navTabs = [...container.querySelectorAll("a.section-tabs__nav-link")]; 
		const inlineTabLinks = [...container.querySelectorAll('a[title="tab-nav-link"]')];
		//replace this with a[title=tab-nav-link] and instruct client to add that to link title
		const indicator = container.querySelector(".section-tabs__indicator");
		const contentArea = container.querySelector(".section-tabs__content");
		const isRMF = !!document.querySelector(".page--RM");
		const isORG = !!document.querySelector(".page--ORG");
		let url = new URL(window.location);
		let activeTab;
		let activeSection;
		const breakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--lg_dn")?.trim().split("px")[0]) || 991;
		let windowWidth = window.innerWidth;
		if (!!navTabs.length) {
			// if redirected from other page with #hash in url, automatically select that tab/section
			// otherwise, select first tab/section
			if (!!url.hash && !!container.querySelector(`a[href='${url.hash}']`)) {
				activeTab = container.querySelector(`a.section-tabs__nav-link[href='${url.hash}']`);
			} else {
				activeTab = navTabs[0];
			}
			
			const updateActive = skipClassUpdates => {
				windowWidth = window.innerWidth;
				// if only updating because of window resize, no need to trigger class update code
				if (!skipClassUpdates) {
					let start = contentArea.offsetHeight;
					contentArea.style.overflow = "hidden";
					container.querySelector("a.active")?.classList.remove("active");
					container.querySelector("div.active")?.classList.remove("active");
					activeTab.classList.add("active");
					activeSection = container.querySelector(activeTab.getAttribute("href"));
					activeSection.classList.add("active");
					let end = contentArea.offsetHeight;
					contentArea.animate([
						{height: start + "px"},
						{height: end + "px"}
					], {
						duration: 300,
						behavior: "smooth"
					});
					setTimeout(() => {
						contentArea.style.overflow = "";
					}, 300)
				}
				let topVal = "calc(100% - 2px)";
				let heightVal = "2";
				if (isRMF) {
					topVal = "calc(100% - 4px)";
					heightVal = "4px";
				} else if (isORG) {
					topVal = "calc(100% - 16px)";
					heightVal = "6px";
				}
				const activeItem = activeTab.closest(".section-tabs__nav-item");
				let leftOffset;
				if (isORG) {
					leftOffset = activeItem.offsetLeft + activeTab.offsetLeft;
				} else {
					leftOffset = activeTab.offsetLeft;
				}
				let width = windowWidth < breakpoint ? heightVal : activeTab.getBoundingClientRect().width + "px";
				let left = windowWidth < breakpoint ? "0" : leftOffset + "px";
				let height = windowWidth >= breakpoint ? heightVal : activeTab.offsetHeight + "px";
				let top = windowWidth >= breakpoint ? topVal : activeTab.offsetTop + "px";
				indicator.style.cssText = `
					width: ${width}; 
					height: ${height};
					top: ${top};
					left: ${left};
				`;
			}
			updateActive();

			// Below used to position page on active tab content if loaded with hash value in url
			const positionPage = () => {
				let existingHash;
				if (!!window.localStorage.getItem("contactFormTabHash")) {
					existingHash = window.localStorage.getItem("contactFormTabHash");
					window.localStorage.removeItem("contactFormTabHash");
				} else {
					existingHash = url.hash;
				}
				const hiddenAnchorToContent = document.createElement("a");
				hiddenAnchorToContent.setAttribute("href", "#section-tabs__hidden-anchor");
				document.body.insertAdjacentElement("beforeend", hiddenAnchorToContent);
				hiddenAnchorToContent.style.display = "none";
				contentArea.setAttribute("id", "section-tabs__hidden-anchor");
				hiddenAnchorToContent.click();
				window.history.replaceState(null, "", url.origin + url.pathname + existingHash);
				hiddenAnchorToContent.remove();
			}
			if (!!url.hash && !!container.querySelector(`a[href='${url.hash}']`)) positionPage();
	
			navTabs.forEach(tab => {
				tab.addEventListener("click", e => {
					e.preventDefault();
					activeTab = tab;
					const hash = tab.getAttribute("href");
					window.history.replaceState(null, "", url.origin + url.pathname + hash);
					updateActive();
				});
			});

			inlineTabLinks.forEach(link => {
				link.addEventListener("click", e => {
					e.preventDefault();
					const hash = link.getAttribute("href");
					activeTab = Array.from(navTabs).find(nav => nav.getAttribute("href") === hash);
					window.history.replaceState(null, "", url.origin + url.pathname + hash);
					updateActive();
					positionPage();
				});
				link.removeAttribute("title");
			});
	
			window.addEventListener("resize", () => {
				let currentWidth = window.innerWidth;
				// if screen resize moves past breakpoint, update position of indicator
				if (currentWidth < breakpoint && windowWidth >= breakpoint
				|| currentWidth >= breakpoint && windowWidth < breakpoint) {
					updateActive(true);
				}
				windowWidth = currentWidth;
			});

			// Code to hijack alchemer form submission to get back to Contact tab after submission
			const hasAlchScript = document.querySelector("script[src*=alchemer]") || false;

			const addHash = (event, bool, resolveFunc) => {
				if (!bool) {
					event.preventDefault();
					window.localStorage.setItem("contactFormTabHash", `#${activeSection.getAttribute("id")}`);
					bool = true;
					setTimeout(resolveFunc, 100);
				}
			}

			const addSubmitListener = async formEl => {
				let submit = formEl.querySelector("input[type=submit], button[type=submit]");
				let submitted = false;
				if (submit) {
					submit.addEventListener("click", async e => {
						await new Promise(resolve => addHash(e, submitted, resolve));
						submitted = true;
						submit.click();
					});
				}
			}

			const setActiveTabFromStorage = () => {
				let hash = window.localStorage.getItem("contactFormTabHash");
				let contactTabLink = document.querySelector(`a[href="${hash}"]`) || false;
				if (contactTabLink) {
					contactTabLink.click();
					history.replaceState(null, "", hash);
					activeTab = contactTabLink;
					updateActive(true);
					positionPage();
					window.localStorage.removeItem("contactFormTabHash");
				}
			}

			if (hasAlchScript) {
				let form = null;
				let i = 0;
				let formCheckInterval = setInterval(() => {
					if (form || i >= 50) {
						clearInterval(formCheckInterval);
						formCheckInterval = null;
						return;
					} else if (!!document.querySelector("form[action*=alchemer]")) {
						form = document.querySelector("form[action*=alchemer]");
						addSubmitListener(form);
						setActiveTabFromStorage();
					}
					i++;
				}, 500);
				
			}
		}
	}
});
